<template>
  <div id="contenedor-listado-estimaciones">
    <v-container fluid rounded>
      <v-card class="mb-4 rounded-lg" flat>
        <v-card-text>
          <titulo-tool-bar
            titulo="Historial de Estimaciones Registradas"
            regresar
            nombreRuta="estimaciones">
            <template v-slot:opciones-derecha>
              <v-chip disabled>
                Total Estimado:
                {{ new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' })
                .format(totalEstimado) }}
              </v-chip>
            </template>
          </titulo-tool-bar>
        </v-card-text>
      </v-card>
      <v-card flat class="rounded-lg">
        <v-card-text>
          <!-- Loader -->
          <v-skeleton-loader
            v-if="$apollo.loading"
            type="table-heading, table-thead, table-tbody"
          ></v-skeleton-loader>
          <v-data-table
            v-else
            :headers="headers"
            :items="listadoEstimaciones"
            :items-per-page="20"
            :page="filtros.numeroPagina"
            :footer-props="{
              'items-per-page-options': [20, 50, 100],
              'show-current-page': true,
              'show-first-last-page': true,
              'items-per-page-text': 'Registros por página',
              'page-text': '{0}-{1} de {2}',
            }"
            :server-items-length="totalRegistros"
            @pagination="changePagination"
          >
          <template v-slot:item.porcentajeAvanceFinanciero="{ item }">
              <v-chip small>
                {{ formatoPorcentaje(item.porcentajeAvanceFinanciero) }}
              </v-chip>
            </template>
            <template v-slot:item.importeNeto="{ item }">
              <v-chip small>
              {{ new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' })
              .format(item.importeNeto) }}
              </v-chip>
            </template>
            <template v-slot:no-data>
              No se encontraron registros
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import LISTADO_ESTIMACIONES from '@/graphql/querys/administracion/ejecucion/estimaciones/estimaciones.gql';
import TituloToolBar from '@/components/TituloToolBar.vue';

export default {
  name: 'ListadoEstimacionesView',
  components: {
    TituloToolBar,
  },
  data() {
    return {
      filtros: {
        idContrato: null,
        fechaDelInicio: null,
        fechaDelFin: null,
        numeroPagina: 1,
        cantidadRegistros: 20,
      },
      headers: [
        {
          text: 'Número de Est.', value: 'numero', sortable: false, align: 'center',
        },
        { text: '% Avance', value: 'porcentajeAvanceFinanciero', sortable: false },
        { text: 'Contrato', value: 'contrato.numero', sortable: false },
        { text: 'Contratista', value: 'contrato.contratista.nombreRazonSocial', sortable: false },
        { text: 'F. de Presentación', value: 'fechaPresentacion', sortable: false },
        { text: 'Fecha Inicio', value: 'fechaDel', sortable: false },
        { text: 'Fecha Fin', value: 'fechaAl', sortable: false },
        {
          text: 'Importe Neto', value: 'importeNeto', align: 'right', sortable: false,
        },
      ],
    };
  },
  apollo: {
    estimaciones: {
      query: LISTADO_ESTIMACIONES,
      variables() {
        console.log(this.filtros);
        return {
          filtros: this.filtros,
        };
      },
      fetchPolicy: 'no-cache',
      error(error) {
        this.$emit('error', error.message);
      },
    },
  },
  mounted() {
    const params = new URLSearchParams(window.location.search);
    if (params.has('idContrato')) {
      this.filtros.idContrato = parseInt(params.get('idContrato'), 10);
    }
    if (params.has('fechaDelInicio')) {
      this.filtros.fechaDelInicio = params.get('fechaDelInicio');
    }
    if (params.has('fechaDelFin')) {
      this.filtros.fechaDelFin = params.get('fechaDelFin');
    }
    if (params.has('numeroPagina')) {
      this.filtros.numeroPagina = parseInt(params.get('numeroPagina'), 10);
    }
    if (params.has('cantidadRegistros')) {
      this.filtros.cantidadRegistros = parseInt(params.get('cantidadRegistros'), 10);
    }

    this.$apollo.queries.estimaciones.refresh();
  },
  methods: {
    changePagination(pagination) {
      this.filtros.numeroPagina = pagination.page;
      this.filtros.cantidadRegistros = pagination.itemsPerPage;
    },
    formatoPorcentaje(valor) {
      const porcentaje = (valor * 100).toFixed(2);
      if (porcentaje === 'NaN') return '0%';
      if (porcentaje >= 100) return '100%';
      return `${porcentaje}%`;
    },
  },
  computed: {
    totalEstimado() {
      if (this.estimaciones) return this.estimaciones.totalEstimado;

      return 0;
    },
    totalRegistros() {
      if (this.estimaciones) return this.estimaciones.totalRegistros;

      return 0;
    },
    listadoEstimaciones() {
      if (!this.estimaciones) return [];

      return this.estimaciones.estimaciones;
    },
  },
  watch: {
    filtros: {
      deep: true,
      handler() {
        this.$apollo.queries.estimaciones.refresh();
        const params = new URLSearchParams();
        Object.entries(this.filtros).forEach(([key, value]) => {
          if (value !== null && value !== undefined && value !== '') {
            params.append(key, value);
          }
        });
        window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
      },
    },
  },
};
</script>

<style lang="scss">

</style>
